const fragments = require('./fragments')(process.env);
const consul = require('./consul')(process.env);
const api = require('./api')(process.env);
const agent = require('./agent')(process.env);
const links = require('./links');


const setTracingAddress = TRACING_ADDRESS => ({ TRACING_ADDRESS });
const setLogsPath = LOGS_PATH => ({ LOGS_PATH });
const setName = SERVICE_NAME => ({ SERVICE_NAME });
const setPort = PORT => ({ PORT });
const setProduction = ENV => ({ PRODUCTION: ENV === 'production' });
const setReleaseStage = RELEASE_STAGE => ({ RELEASE_STAGE });
const setJWKSUri = JWKS_URI => ({ JWKS_URI });
const setCookiesDomain = COOKIES_DOMAIN => ({ COOKIES_DOMAIN });
const setGateway = GATEWAY => ({ GATEWAY });
const setHiddenPageSecret = HIDDEN_PAGE_SECRET => ({ HIDDEN_PAGE_SECRET });
const setTimeout = TIMEOUT => ({ TIMEOUT });
const setWebpushUrl = WEBPUSH_URL => ({ WEBPUSH_URL });
const setAccountClientId = ACCOUNT_CLIENT_ID => ({ ACCOUNT_CLIENT_ID });
const setAccountClientSecret = ACCOUNT_CLIENT_SECRET => ({ ACCOUNT_CLIENT_SECRET });

module.exports = {
  API: api,
  CONSUL: consul,
  AGENT: agent,
  FRAGMENTS: fragments,
  ...links,
  ...setTracingAddress(process.env.TRACING_ADDRESS),
  ...setLogsPath(process.env.LOGS_PATH),
  ...setName(process.env.SERVICE_NAME),
  ...setPort(Number(process.env.PORT)),
  ...setProduction(process.env.NODE_ENV),
  ...setReleaseStage(process.env.RELEASE_STAGE),
  ...setJWKSUri(process.env.JWKS_URI),
  ...setCookiesDomain(process.env.COOKIES_DOMAIN),
  ...setGateway(process.env.GATEWAY),
  ...setHiddenPageSecret(process.env.HIDDEN_PAGE_SECRET),
  ...setTimeout(process.env.TIMEOUT),
  ...setWebpushUrl(process.env.WEBPUSH_URL),
  ...setAccountClientId(process.env.ACCOUNT_CLIENT_ID),
  ...setAccountClientSecret(process.env.ACCOUNT_CLIENT_SECRET)
};
